<script setup>
const emit = defineEmits(['addToCart', 'backPrev']);
</script>

<template>
  <div class="modal com_modal2 fade" id="noAddCartConfirmModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1 com_mgb5 com_lh1">表示中の商品を<br>カートに入れますか？</h3>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_app_btn1" data-bs-dismiss="modal" @click="emit('addToCart')">カートに追加</button>
          <button type="button" class="btn com_app_btn2" data-bs-dismiss="modal" @click="emit('backPrev')">追加しない</button>
        </div>
      </div>
    </div>
  </div>
</template>